import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ReferralLinkCard } from "@/components/referrals/ReferralLinkCard";
import { PartnerShell, Notice } from "@/pages/partners/PartnerShell";
import { api, errMsg } from "@/lib/api";
import { pct } from "@/lib/referral";

function Done({ done, program }) {
  return (
    <div className="mx-auto max-w-2xl space-y-4" data-testid="partner-signup-done">
      <Notice title="Cadastro feito!" text={done.email_sent ? "Enviamos o link do seu painel para o seu e-mail. Use sempre esse mesmo link para entrar." : "Guarde o link do seu painel abaixo. Use sempre esse mesmo link para entrar."}>
        <Button asChild data-testid="partner-open-panel-btn"><Link to={new URL(done.panel_url).pathname}>Abrir meu painel</Link></Button>
      </Notice>
      <ReferralLinkCard link={done.link} program={program} />
    </div>
  );
}

export default function PartnerSignup() {
  const { invite } = useParams();
  const [info, setInfo] = useState(null);
  const [f, setF] = useState({ name: "", email: "", pix_key: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  useEffect(() => { api.get(`/public/partners/invite/${invite}`).then((r) => setInfo(r.data)).catch(() => setInfo({ valid: false })); }, [invite]);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setDone((await api.post("/public/partners/signup", { ...f, invite })).data); } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };
  if (!info) return <PartnerShell><p className="text-sm text-muted-foreground">Carregando...</p></PartnerShell>;
  if (!info.valid) return <PartnerShell><Notice testId="partner-invite-invalid" title="Link de cadastro inválido" text="Este link não é mais válido. Peça um novo link para quem enviou."><Link to="/parceiros/entrar" className="text-sm text-primary underline">Já tenho cadastro</Link></Notice></PartnerShell>;
  if (done) return <PartnerShell><Done done={done} program={info.program} /></PartnerShell>;
  return (
    <PartnerShell>
      <form onSubmit={submit} className="card-surface mx-auto max-w-lg space-y-4 p-6" data-testid="partner-signup-form">
        <div>
          <h1 className="font-display text-2xl font-bold">Seja um parceiro</h1>
          <p className="mt-1 text-sm text-muted-foreground">{info.program.active ? `Indique o sistema e ganhe ${pct(info.program.percent)} de cada mensalidade paga pelos seus indicados.` : "Cadastre-se para receber seu link de indicação."}</p>
        </div>
        <div className="space-y-1.5"><Label>Nome completo</Label><Input value={f.name} onChange={set("name")} required minLength={2} data-testid="partner-name-input" /></div>
        <div className="space-y-1.5"><Label>E-mail</Label><Input type="email" value={f.email} onChange={set("email")} required data-testid="partner-email-input" /></div>
        <div className="space-y-1.5"><Label>Chave Pix</Label><Input value={f.pix_key} onChange={set("pix_key")} required placeholder="CPF, CNPJ, celular, e-mail ou chave aleatória" data-testid="partner-pix-input" /></div>
        <Button type="submit" className="w-full" disabled={busy} data-testid="partner-signup-submit-btn">{busy ? "Enviando..." : "Quero meu link de indicação"}</Button>
        <p className="text-center text-sm"><Link to="/parceiros/entrar" className="text-primary underline" data-testid="partner-have-account-link">Já tenho cadastro</Link></p>
      </form>
    </PartnerShell>
  );
}
